import React from 'react';
import { useSelector } from 'react-redux';
import * as selectors from '../../selectors';
import { IntegrationDetailsContent } from './components/IntegrationDetailsContent';

/**
 * Displays details for an integration belonging to the selected company.
 *
 * @param {object} props
 * @param {string} props.companyId
 * @param {string} props.integrationId
 * @param {Function|null} props.onClose
 */
export const IntegrationsDetailsModal = ({ companyId, integrationId, onClose = null }) => {
    const integration = useSelector(state => (
        selectors.getIntegrationForCompany(state, integrationId)
    ));

    if (!integration) return null;

    return (
        <IntegrationDetailsContent
            companyId={companyId}
            integration={integration}
            onClose={onClose}
        />
    );
};

export default IntegrationsDetailsModal;
